import { createSelector } from "@reduxjs/toolkit";

const getTextById = (state, props) =>
	state.texts.itemsById[props.textId || props.id];

const getTextByIdSelector = createSelector(getTextById, (text) => {
	return text && text.value;
});

export function makeGetTextByIdSelector() {
	return getTextByIdSelector;
}
